"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Breadcrumbs = void 0;
var React = _interopRequireWildcard(require("react"));
var _classify = _interopRequireDefault(require("../../utils/classify"));
var _Icon = require("../Icon");
var _BreadcrumbsModule = _interopRequireDefault(require("./Breadcrumbs.module.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const BreadcrumbSeparator = () => /*#__PURE__*/React.createElement(_Icon.Icon, {
  className: _BreadcrumbsModule.default.separator,
  name: "chevron-right",
  size: "small",
  color: "secondary"
});
const Breadcrumbs = exports.Breadcrumbs = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    classNames,
    children,
    linkComponent
  } = _ref;
  const total = React.Children.count(children);
  return /*#__PURE__*/React.createElement("div", {
    ref: ref,
    "data-testid": "Breadcrumbs",
    className: (0, _classify.default)(_BreadcrumbsModule.default.wrapper, classNames?.wrapper)
  }, React.Children.map(children, (child, idx) =>
  /*#__PURE__*/
  // eslint-disable-next-line react/no-array-index-key
  React.createElement(React.Fragment, {
    key: `crumb-${idx}`
  }, /*#__PURE__*/React.isValidElement(child) &&
  // @ts-ignore - TS2339 - Property 'displayName' does not exist on type 'string | JSXElementConstructor<any>'.
  child?.type?.displayName === 'BreadcrumbLink' ?
  /*#__PURE__*/
  // @ts-ignore - TS2769 - No overload matches this call.
  React.cloneElement(child, {
    linkComponent
  }) : child, idx < total - 1 && /*#__PURE__*/React.createElement(BreadcrumbSeparator, {
    "aria-hidden": true
  }))));
});